import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface BlogPostLinkProps {
  to: string;
  children: ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const BlogPostLink = ({ to, children, className, onClick }: BlogPostLinkProps) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Call any additional onClick handler first
    if (onClick) {
      onClick(e);
    }
    
    // Open ad page in new tab
    window.open('/ad-redirect', '_blank', 'noopener,noreferrer');
    
    // Navigate to the blog post in current tab
    navigate(to);
  };

  return (
    <a
      href={to}
      onClick={handleClick}
      className={className}
    >
      {children}
    </a>
  );
};

export default BlogPostLink;
